export const asyncExportMessages = {
	CONFIRMATION_MODAL: {
		title: 'Sua exportação será processada em segundo plano.',
		description:
			'Isso pode levar alguns minutos devido ao volume de dados. Assim que o arquivo estiver pronto, você poderá baixá-lo pelo e-mail enviado ou pela área de Atividades Recentes do sistema, onde o link de download também ficará disponível.',
		confirmButton: 'OK, entendi e desejo continuar',
		cancelButton: 'Cancelar',
	},

	ONGOING_MODAL: {
		title: 'Já existe uma exportação em andamento.',
		description:
			'Você pode acompanhar o progresso ou solicitar uma nova exportação.',
		description2:
			'A exportação atual continuará normalmente se você não solicitar uma nova.',
		confirmButton: 'Solicitar nova exportação',
		cancelButton: 'Manter exportação atual (recomendado)',
	},
} as const;

export type AsyncExportMessageType =
	(typeof asyncExportMessages)[keyof typeof asyncExportMessages];
